module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "1magnifying-glass.149046e5.svg";